import { render, staticRenderFns } from "./intranetBusinessOrderManagement.vue?vue&type=template&id=1108988c&scoped=true"
import script from "./intranetBusinessOrderManagement.vue?vue&type=script&lang=js"
export * from "./intranetBusinessOrderManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1108988c",
  null
  
)

export default component.exports